// extracted by mini-css-extract-plugin
module.exports = {"navList":"menu-module--navList--36w8O","navItem":"menu-module--navItem--1k8qy","activeNavItem":"menu-module--active-nav-item--3QKa2"};